import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function WhatsAppButton() {
  const msg = encodeURIComponent(
    "Hello Desi Masala Hub, I would like to request a wholesale quote."
  );
  return (
    <a
      href={`https://wa.me/${BRAND.whatsapp}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-sticky-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30"></span>
      <span className="relative flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white pl-4 pr-5 py-3.5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105">
        <MessageCircle className="w-5 h-5" fill="currentColor" />
        <span className="hidden sm:inline text-sm font-semibold tracking-wide">WhatsApp Inquiry</span>
      </span>
    </a>
  );
}
